import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalButton } from './';
import AddIcon from '@mui/icons-material/Add';

/**
 * Standardized Add Button component for modals
 * Pre-configured with contained variant, primary color, and Add icon
 */
const ModalAddButton = ({ onClick, children, sx, ...props }) => {
  const { t } = useTranslation();
  
  return (
    <ModalButton
      variant="contained"
      color="primary"
      onClick={onClick}
      startIcon={<AddIcon />}
      sx={sx}
      {...props}
    >
      {children || t('modals.add')}
    </ModalButton>
  );
};

export default ModalAddButton;